import type { PersonType } from '@dealstack/prisma-client';

export function isPersonLegal(personType: PersonType): boolean {
	return personType === 'LEGAL';
}
export function isPersonNatural(personType: PersonType): boolean {
	return personType === 'NATURAL';
}
